export default "__VITE_ASSET__y2rfEK3H__"